
export const theme = {
    colors: {
        primaryBg: '#e1d0ff',
        secondaryBg: '#fde8fd',
        accent: '#7572D5',
        font: '#211f26',
        icon: '#7572D5',
        placeholder: "#590de5",
        headerFooter: "#faddfa"
    },

    media: {
        tablet: "screen and (max-width: 768px)",
        mobile: "screen and (max-width: 576px)",
        desktop: "screen and (min-width: 1140px)",
    },

    animation: {
        transition: " .2s ease-in-out;"
    }

}